import {
    faBadgeCheck,
    faCalendarLines,
    faClock,
    faCoins,
    faFire,
    faMemoPad,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IssueMetricType } from 'shared/issue_metrics/types';
import { Lookup } from 'utils/types';

export type MetricColorConfig = {
    background: string;
    icon: string;
};

export const METRIC_COLORS: Lookup<IssueMetricType, MetricColorConfig | undefined> = {
    new: {
        background: 'var(--metric-new-background)',
        icon: 'var(--metric-new-icon)',
    },
    open: {
        background: 'var(--metric-open-background)',
        icon: 'var(--metric-open-icon)',
    },
    draft: {
        background: 'var(--metric-draft-background)',
        icon: 'var(--metric-draft-icon)',
    },
    resolved: {
        background: 'var(--metric-resolved-background)',
        icon: 'var(--metric-resolved-icon)',
    },
    days: {
        background: 'var(--metric-days-background)',
        icon: 'var(--metric-days-icon)',
    },
    downtime: {
        background: 'var(--metric-downtime-background)',
        icon: 'var(--metric-downtime-icon)',
    },
    savings: {
        background: 'var(--metric-savings-background)',
        icon: 'var(--metric-savings-icon)',
    },
    severe: {
        background: 'var(--metric-severe-background)',
        icon: 'var(--metric-severe-icon)',
    },
    'issue-addressed': {
        background: 'var(--metric-resolved-background)',
        icon: 'var(--metric-resolved-icon)',
    },
};

export const METRIC_ICONS: Lookup<IssueMetricType, JSX.Element> = {
    new: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    open: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    draft: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    resolved: <FontAwesomeIcon icon={faBadgeCheck} size="sm" />,
    severe: <FontAwesomeIcon icon={faFire} size="sm" />,
    days: <FontAwesomeIcon icon={faCalendarLines} size="sm" />,
    downtime: <FontAwesomeIcon icon={faClock} size="sm" />,
    savings: <FontAwesomeIcon icon={faCoins} size="sm" />,
    'issue-addressed': <FontAwesomeIcon icon={faBadgeCheck} size="sm" />,
};

export function MetricIcon({ type }: { type: IssueMetricType }) {
    return METRIC_ICONS[type];
}
